module.exports = __webpack_public_path__ + "static/media/stop_share_screen_camera.e97603d9.svg";